export const PROJECT_TYPE = {
  JS: "JS",
  OOBC: "OOBC",
};

export const STUDIO_LANG_TYPE = {
  BLOCK: "block",
  TEXT: "text",
};
